import { render, staticRenderFns } from "./BetaProgramComponent.vue?vue&type=template&id=4ba0cef5"
import script from "./BetaProgramComponent.vue?vue&type=script&lang=js"
export * from "./BetaProgramComponent.vue?vue&type=script&lang=js"
import style0 from "./BetaProgramComponent.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports